export function _print(printMode, autoBounds) {
  this._map.fire(L.BrowserPrint.Event.PrintInit, { mode: printMode })
  if (this.options.cancelWithEsc) {
    L.DomEvent.on(document, 'keyup', this._keyUpCancel, this)
  }
  L.BrowserPrint.Utils.initialize()

  var self = this
  var mapContainer = this._map.getContainer()
  var options = printMode.options
  var pageOrientation = options.orientation

  var origins = {
    bounds: autoBounds || this._map.getBounds(),
    width: mapContainer.style.width,
    height: mapContainer.style.height,
    documentTitle: document.title,
    printLayer: L.BrowserPrint.Utils.cloneLayer(this.options.printLayer),
    panes: []
  }

  var mapPanes = this._map.getPanes()

  // Добавлен текущий zIndex для pane
  for (var pane in mapPanes) {
    origins.panes.push({ name: pane, container: undefined, zIndex: mapPanes[pane].style.zIndex ? parseInt(mapPanes[pane].style.zIndex) : 0 })
  }
  // Сортируем panes по их zIndex, чтобы сохранить порядок слоев в печатаемом док-те
  origins.panes.sort((x, y) => {
    return x.zIndex > y.zIndex ? 1 : x.zIndex < y.zIndex ? -1 : 0
  })

  origins.printObjects = this._getPrintObjects(origins.printLayer)

  this._map.fire(L.BrowserPrint.Event.PrePrint, {
    printLayer: origins.printLayer,
    printObjects: origins.printObjects,
    pageOrientation,
    printMode: options.mode,
    pageBounds: origins.bounds
  })

  if (this.cancelNextPrinting) {
    this._printCancel()
    return
  }

  var overlay = this._addPrintMapOverlay(printMode, pageOrientation, origins)

  if (this.options.documentTitle) {
    document.title = this.options.documentTitle
  }

  this._map.fire(L.BrowserPrint.Event.PrintStart, { printLayer: origins.printLayer, printMap: overlay.map, printObjects: overlay.objects })

  if (options.invalidateBounds) {
    overlay.map.fitBounds(origins.bounds)
    overlay.map.invalidateSize({ reset: true, animate: false, pan: false })
  } else {
    overlay.map.setView(this._map.getCenter(), this._map.getZoom())
  }

  if (options.zoom) {
    overlay.map.setZoom(options.zoom)
  } else if (!options.enableZoom) {
    overlay.map.setZoom(this._map.getZoom())
  }

  if (!this.options.debug) {
    this.printInterval = setInterval(function() {
      if (self.cancelNextPrinting || !self._map.isPrinting) {
        clearInterval(self.printInterval)
      } else if (self._map.isPrinting && !self._isTilesLoading(overlay.map)) {
        clearInterval(self.printInterval)
        if (self.options.manualMode) {
          self._setupManualPrintButton(overlay.map, origins, overlay.objects)
        } else {
          self._completePrinting(overlay.map, origins, overlay.objects)
        }
      }
    }, 50)
  }
}

// Фикс для вывода на печать canvas слоя
export function _registerRenderer(array, type, identifier, builderFunction) {
  if (
    type &&
    !array.filter(function(l) {
      return l.identifier === identifier
    }).length
  ) {
    array.push({
      type: type,
      identifier: identifier,
      builder:
        builderFunction ||
        function(layer) {
          return new type(layer.options || layer)
        }
    })
  }
}

// Фикс для игнорирования с-ва window.devicePixelRatio
export function getSize(mode, orientaion = 'Portrait') {
  var size = this.getPaperSize(mode)
  var pageMargin = this.getPageMargin(mode, 0)

  var topbottom =
    orientaion === 'Portrait' ? parseFloat(pageMargin.top) + parseFloat(pageMargin.bottom) : parseFloat(pageMargin.left) + parseFloat(pageMargin.right)
  var leftright =
    orientaion === 'Portrait' ? parseFloat(pageMargin.left) + parseFloat(pageMargin.right) : parseFloat(pageMargin.top) + parseFloat(pageMargin.bottom)

  var height = Math.floor(size.Height - topbottom)
  var width = Math.floor(size.Width - leftright)

  size.Width = width + 'mm'
  size.Height = height + 'mm'

  return size
}

// Фикс для автопечати - печатаем то, что видно на экране
export function _printAuto(mode) {
  this._addPrintClassToContainer(this._map, 'leaflet-browser-print--auto')

  var autoBounds = this._map.getBounds()
  var orientation
  if (mode.options.orientation === 'Portrait' || mode.options.orientation === 'Landscape') {
    orientation = mode.options.orientation
  } else {
    orientation = this._getPageSizeFromBounds(autoBounds)
  }
  this._print(this._getMode(orientation, mode), autoBounds)
}



// WEBPACK FOOTER //
// ./src/helpers/overwrittenBrowserPrint.js